<template>
  <v-card>
    <v-layout>
      <v-app-bar color="primary">
        <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

        <v-toolbar-title>RDS - Overview</v-toolbar-title>

        <v-spacer></v-spacer>

        <template v-if="!loading_dashboard" )>
          <v-chip class="mr-2" :color="dashboard.data.ewon_online != Object.keys(dashboard.data.data).length ? 'orange' : 'green'"
            variant="elevated"> EWON: {{ dashboard.data.ewon_online }} / {{ Object.keys(dashboard.data.data).length }} <v-tooltip
              activator="parent" location="bottom">Latest update: {{ dashboard.data.timestamp }} UTC</v-tooltip></v-chip>
          <v-chip class="mr-2" :color="dashboard.data.rms_active != dashboard.data.rms_online ? 'orange' : 'green'"
            variant="elevated"> RMS: {{ dashboard.data.rms_online }} / {{ dashboard.data.rms_active }} <v-tooltip
              activator="parent" location="bottom">Latest update: {{ dashboard.data.timestamp }} UTC</v-tooltip></v-chip>
          <v-chip class="mr-2" :color="dashboard.data.cim_active != dashboard.data.cim_online ? 'orange' : 'green'"
            variant="elevated"> CIM: {{ dashboard.data.cim_online }} / {{ dashboard.data.cim_active }} <v-tooltip
              activator="parent" location="bottom">Latest update: {{ dashboard.data.timestamp }} UTC</v-tooltip></v-chip>
        </template>
        <template v-else>
          <span class="mr-2">Loading data..</span>
        </template>

      </v-app-bar>

      <v-navigation-drawer v-model="drawer">
        <v-list>

          <v-list-item to="/">Dashboard</v-list-item>

          <v-list-group value="Machine">
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" title="Machine"></v-list-item>
            </template>

            <v-list-item v-for="machine in dashboard.data.data" :to="machine.machine">{{ machine.machine }}</v-list-item>

          </v-list-group>

          <v-list-group value="Company">
            <template v-slot:activator="{ props }">
              <v-list-item v-bind="props" title="Company"></v-list-item>

            </template>

            <v-list-group v-for="company in dashboard.data.company" :value="company.name">
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props" :title="company.name"></v-list-item>
              </template>

              <v-list-item v-for="machine in company.machines" :to="machine.machine">{{ machine.machine }}</v-list-item>

            </v-list-group>

          </v-list-group>

        </v-list>

      </v-navigation-drawer>

      <v-main>
        <router-view />
      </v-main>
    </v-layout>
  </v-card>
</template>

<script>
import axios from "axios";

import { useDashboardStore } from '@/stores/dashboard'

export default {

  data() {
    return {
      loading_dashboard: true,
      drawer: false,
      group: null,
      dashboard: useDashboardStore(), // Use Pinia store
    }
  },

  watch: {
    group() {
      this.drawer = false
    },
  },

  mounted() {

    this.updateDashboard();
    setInterval(() => {
      this.updateDashboard();
    }, 30000);

  },

  methods: {
    updateDashboard: function () {
      axios
        .get(`https://rdsstatus.ramgaard.net/api/app/get_dashboard.php?t=${new Date().getTime()}`)
        .then(response => {
          this.dashboard.setData(response.data);
          this.loading_dashboard = false;
        });
    }
  },

}
</script>